import { render, staticRenderFns } from "./formNew.vue?vue&type=template&id=824438d8"
import script from "./formNew.vue?vue&type=script&lang=js"
export * from "./formNew.vue?vue&type=script&lang=js"
import style0 from "./formNew.vue?vue&type=style&index=0&id=824438d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports